// src/pages/DashboardPage.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSubdomain } from '../contexts/SubdomainContext';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import SubdomainTester from '../components/SubdomainTester';
import SubdomainDebugger from '../components/SubdomainDebugger';

const DashboardPage = () => {
    const { currentUser, accountId, loading } = useAuth();
    const { subdomain, hasSubdomain } = useSubdomain();
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState('');

    // 認証状態の読み込みが完了し、ユーザーがログインしていない場合はログインページへリダイレクト
    if (!loading && !currentUser) {
        navigate('/login');
        return null;
    }

    useEffect(() => {
        // locationのstateからメッセージを取得
        if (location.state?.message) {
            setMessage(location.state.message);
            // メッセージを表示後、stateをクリア
            navigate(location.pathname, { replace: true });
        }
    }, [location, navigate]);

    // サブドメイン情報はSubdomainContextから取得するため、useEffectは不要

    return (
        <div>
            <Header /> {/* Headerコンポーネントを表示 */}
            <main style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
                <h2>ダッシュボード</h2>

                {message && (
                    <div style={{
                        background: '#d4edda',
                        color: '#155724',
                        padding: '12px',
                        borderRadius: '6px',
                        marginBottom: '20px',
                        border: '1px solid #c3e6cb'
                    }}>
                        {message}
                    </div>
                )}

                {currentUser && (
                    <p>
                        こんにちは、{currentUser.displayName || currentUser.email}さん！
                    </p>
                )}

                {/* サブドメイン情報 */}
                <div style={{
                    background: '#f8f9fa',
                    padding: '20px',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    border: '1px solid #e9ecef'
                }}>
                    <h3>あなたのWebサイトURL</h3>
                    {hasSubdomain && subdomain ? (
                        <div>
                            <p style={{
                                fontSize: '18px',
                                color: '#007bff',
                                fontWeight: 'bold',
                                marginBottom: '10px'
                            }}>
                                {subdomain.subdomain}.suisui.life
                            </p>


                            <a
                                href={`https://${subdomain.subdomain}.suisui.life`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    background: '#007bff',
                                    color: 'white',
                                    padding: '8px 16px',
                                    borderRadius: '4px',
                                    textDecoration: 'none',
                                    marginRight: '10px'
                                }}
                            >
                                サイトを表示
                            </a>
                        </div>
                    ) : (
                        <div>
                            <p>サブドメイン設定が完了していません。</p>
                            <p style={{ color: '#dc3545', fontSize: '14px' }}>
                                注意: サブドメインが設定されていないため、このページは通常表示されません。
                            </p>
                        </div>
                    )}
                </div>

                <p>ここは将来的に統計情報などを表示するエリアです。</p>

                {/* 開発環境でのサブドメインテスター */}
                {process.env.NODE_ENV === 'development' && (
                    <SubdomainTester />
                )}

                {/* 自動承認デバッガー（開発環境のみ） */}
                {process.env.NODE_ENV === 'development' && (
                    <SubdomainDebugger />
                )}

            </main>
        </div>
    );
};

export default DashboardPage;